<div class="relative h-2.5 w-full bg-po-gray-200">
  <div
    class="absolute left-0 top-0 h-full transition-all duration-300 ease-in-out"
    [ngClass]="{
      'rounded-r-full': progress !== 100
    }"
    [style.width.%]="progress"
    data-testid="progress"
    style="
      background: linear-gradient(
          90deg,
          #6e4fdb 10.49%,
          rgba(110, 79, 219, 0) 100%
        ),
        #75c9eb;
    "
  ></div>
</div>
